export default __webpack_public_path__ + "static/media/roadmap_3.1a3a1048.png";